export const formatDate = (date) => {
	const dateFormatter = new Intl.DateTimeFormat('de-DE', {dateStyle: 'medium'});
	return dateFormatter.format(new Date(date));
};

export const formatTime = (date) => {
	const dateFormatter = new Intl.DateTimeFormat('de-DE', {hour: '2-digit', minute: '2-digit'});
	return dateFormatter.format(date);
}

export const isNextDay = (date) => {
	const today = new Date();
	const dayForDate = new Date(date);
	const nextDayDate = dayForDate.setDate(dayForDate.getDate() + 1);
	return nextDayDate < today;
};
